
let commonMsgs = {}

commonMsgs.SUC_MSG = "success"
commonMsgs.FAIL_MSG = "failure"
commonMsgs.NETWORK_ERROR = "Network Error"


export { commonMsgs }